import { render, staticRenderFns } from "./asset-versions.vue?vue&type=template&id=51bfb0da&scoped=true&"
import script from "./asset-versions.vue?vue&type=script&lang=js&"
export * from "./asset-versions.vue?vue&type=script&lang=js&"
import style0 from "./asset-versions.vue?vue&type=style&index=0&id=51bfb0da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bfb0da",
  null
  
)

export default component.exports